import React from 'react';
import NextStep from '../elements/NextStep';
import PropTypes from 'prop-types';

import DifficultyAwareComponent from "../DifficultyAwareComponent";
import ContentContainer from "../elements/ContentContainer";
import SectionHeading from "../elements/SectionHeading";
import BudgetSlider from "../elements/StepThree/BudgetSlider";
import BudgetCollaboration from "../elements/StepThree/BudgetCollaboration";
import PolicyElement from "./PolicyElement";
import {
  calculateBudgetPRO, calculateSavingsAndLoans,
  calculateBudgetBASIC,
} from '../../helpers/calculationsHelper';
import { getSelectedPolicyChoicesCount } from '../../helpers/policyChoiceHelper';

import Globas from "../../assets/img/icons/globas.svg";
import Shadow from "../../assets/img/MapElements/shadow.png";
import Beleidskeuze from "../../assets/img/icons/beleidskeuze.svg";
import connect from "react-redux/es/connect/connect";
import {__, __n} from "i18n-for-browser";
import {mapColors, mapElements, ministryIcons} from "../../assets/assets";
import Defines from "../../Defines";
import { gameStateInput } from '../../actions';
import { policiesForMinisterie } from '../../helpers/policyChoiceHelper';
import PopupTitle from "../elements/PopupTitle";
import GoBackButton from "../elements/GoBackButton";
import {getMinistryARating, getMinistryColor, ministryOverfinanced} from "../../helpers/feedbackHelpers";
import Scrollbar from "react-scrollbars-custom";
import PopUp from '../elements/PopUp';

const { updateMyState } = gameStateInput;

let iconSize = 2;

/**
 * Import assets
 */
class MinistryBudget extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      ministry: this.props.match.params.id.toUpperCase(),
      allChoicesMadePopup: false,
    };
    this.maxVal = undefined;
  }

  setImage = (min, value, difficulty) => {
    let type;
    if (difficulty === 'pro') {
      if (ministryOverfinanced(min, this.props.gameState)) type = 5;
      else type = getMinistryARating(difficulty, min, value, this.props.feedback.prevRoundFeedbackData) + 1;
      if (Defines.i18nMinistries.indexOf(min) !== -1 && type > 2) type -= 1;
    } else if (difficulty === 'basic') {
      const color = getMinistryColor(difficulty, min, this.props.gameState, this.props.gameStateInput, this.props.feedback.prevRoundFeedbackData);
      const internationalMinistry = Defines.i18nMinistries.indexOf(min) !== -1;
      if (internationalMinistry) {
        if (color === 'red') type = 1;
        if (color === 'orange' || color === 'lowOrange') type = 2;
        if (color === 'yellow' || color === 'lowYellow') type = 2;
        if (color === 'green') type = 3;
        if(ministryOverfinanced(min, this.props.gameState)) type = 4;
      } else {
        if (color === 'red') type = 1;
        if (color === 'orange' || color === 'lowOrange') type = 2;
        if (color === 'yellow' || color === 'lowYellow') type = 3;
        if (color === 'green') type = 4;
        if(ministryOverfinanced(min, this.props.gameState)) type = 5;
      }
    }
    return mapElements[`map_${min}__${min}${type}${iconSize !== false ? `${iconSize}x` : ''}`];
  };

  setPlateau = (min, value, difficulty) => {
    const color = getMinistryColor(difficulty, min, this.props.gameState, this.props.gameStateInput, this.props.feedback.prevRoundFeedbackData);
    return mapColors[difficulty + '_' + color];
  };

  renderLaag() {
    const { gameState, myState, dispatch, policyChoice, loaded, gameStateInput } = this.props;
    const ministry = this.props.match.params.id.toUpperCase();

    const {
      ministerieGlobaVerdeling,
      policyChoices,
    } = myState;
    const globas = calculateBudgetBASIC(
      gameState,
      policyChoices,
      ministerieGlobaVerdeling,
      calculateSavingsAndLoans(gameStateInput),
      policyChoice,
    );
    const international = Defines.i18nMinistries.includes(ministry);

    if (!this.maxVal && loaded) {
      if ((globas + (ministerieGlobaVerdeling[ministry] || 0)) > 20) {
        this.maxVal = 20;
      } else {
        this.maxVal = globas + (ministerieGlobaVerdeling[ministry] || 0);
      }
    }
    return (
      <div className={'darkBckg'}>
        <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
          <div className='container ministry-budget-container'>
            <div className={'small-policy'}>
              <div className="title-block">
                <span>
                  <img alt="icon" src={ministryIcons[ministry]}/>

                  <PopupTitle customClass={'popup-heading'} popupId={'d' + Defines.ministryPopupIds.basic[ministry].substring(1)} tag={'h4'}/>
                </span>

                <GoBackButton history={this.props.history}/>
              </div>

              <div className={'policy-content-box'}>
                <div className={'map-icon'}>
                  <img src={ this.setImage(ministry, gameState.gameStateSum[`${ministry}_value`], gameState.difficulty.toLowerCase()) } alt={__(ministry)}/>
                  <img className={'plateau'} src={ this.setPlateau(ministry, gameState.gameStateSum[`${ministry}_value`], gameState.difficulty.toLowerCase()) } alt={'plateau'}/>
                  <img className={'shadow'} src={Shadow} alt={'shadow'}/>
                </div>

                <ContentContainer>
                  <h3 className={'popup-heading'}>{__("sim_vraag_hoeveel_globas_aan_ministerie")}</h3>
                  <BudgetSlider
                    role={this.props.user.role}
                    key={ministry}
                    unit={__('sim_miljard')}
                    value={ministerieGlobaVerdeling[ministry] || 0}
                    disabled={globas < 0}
                    customOnChange={(k, v) => {
                      const globasLeft = globas + (ministerieGlobaVerdeling[ministry] || 0) - v;
                      if (globasLeft >= 0 || v < (ministerieGlobaVerdeling[ministry] || 0)) {
                        dispatch(updateMyState({
                          ministerieGlobaVerdeling: {
                            ...ministerieGlobaVerdeling,
                            [ministry]: v,
                          },
                        }));
                        return;
                      }
                      if (globasLeft < 0) {
                        dispatch(updateMyState({
                          ministerieGlobaVerdeling: {
                            ...ministerieGlobaVerdeling,
                            [ministry]: (ministerieGlobaVerdeling[ministry] || 0) + globas,
                          },
                        }));
                      }
                    }}
                    min={0}
                    max={this.maxVal}
                    ignoreMax={true}/>

                  {international ? (
                    <BudgetCollaboration
                      value={ministerieGlobaVerdeling[`${ministry}SW`]}
                      customOnChange={(k,v) => {
                        dispatch(updateMyState({
                          ministerieGlobaVerdeling: {
                            ...ministerieGlobaVerdeling,
                            [`${ministry}SW`]: v,
                          },
                        }));
                      }}
                      title={__('sim_selecteer_samenwerk_landen') + ':'}
                    />
                  ) : null}
                </ContentContainer>
              </div>
            </div>
          </div>

        </Scrollbar>
        <NextStep/>
      </div>
    );
  }

  renderHoog() {
    const { gameStateInput, gameState, myState, dispatch, policyChoice, loaded } = this.props;
    const ministry = this.props.match.params.id.toUpperCase();

    const {
      ministerieGlobaVerdeling,
      policyChoices,
    } = myState;
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetPRO(gameState, gameStateInput, policyChoices, myState.ministerieGlobaVerdeling, savingsAndLoans);
    const international = Defines.i18nMinistries.includes(ministry);
    if (!this.maxVal && loaded) {
      if ((globas + (ministerieGlobaVerdeling[ministry] || 0)) > 100) {
        this.maxVal = 100;
      } else {
        this.maxVal = globas + (ministerieGlobaVerdeling[ministry] || 0);
      }
    }

    return (
      <div className={'darkBckg'}>
        <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
          <div className='container ministry-budget-container hoog'>
            <div className="title-block">
              <img alt="icon" src={ministryIcons[ministry]}/>

              <PopupTitle customClass={'popup-heading'} popupId={'d' + Defines.ministryPopupIds.pro[ministry].substring(1)} tag={'h4'}/>

              <GoBackButton history={this.props.history}/>
            </div>

            <div className={'policy-content-wrapper'}>
              <div className={'policy-content-box'}>
                <SectionHeading
                  icon={Globas}
                  title={__('sim_budgetkeuze')}
                  popupId={'dhgvtbudgetkeuze'}/>

                <ContentContainer className={international ? '' : 'national-ministry'}>
                  <BudgetSlider
                    role={this.props.user.role}
                    unit={__('sim_miljard')}
                    disabled={globas < 0}
                    value={ministerieGlobaVerdeling[ministry] || 0}
                    customOnChange={(k, v) => {
                      const globasLeft = globas + (ministerieGlobaVerdeling[ministry] || 0) - v;
                      if (globasLeft >= 0 || v < (ministerieGlobaVerdeling[ministry] || 0)) {
                        dispatch(updateMyState({
                          ministerieGlobaVerdeling: {
                            ...ministerieGlobaVerdeling,
                            [ministry]: v,
                          },
                        }));
                        return;
                      }
                      if (globasLeft < 0) {
                        dispatch(updateMyState({
                          ministerieGlobaVerdeling: {
                            ...ministerieGlobaVerdeling,
                            [ministry]: (ministerieGlobaVerdeling[ministry] || 0) + globas,
                          },
                        }));
                      }
                    }}
                    min={0}
                    max={this.maxVal}
                    ignoreMax={true}
                  />

                  {international ? (
                    <BudgetCollaboration
                      value={ministerieGlobaVerdeling[`${ministry}SW`]}
                      customOnChange={(k,v) => {
                        dispatch(updateMyState({
                          ministerieGlobaVerdeling: {
                            ...ministerieGlobaVerdeling,
                            [`${ministry}SW`]: v,
                          },
                        }));
                      }}
                      title={__('sim_selecteer_samenwerk_landen') + ':'}
                    />
                  ) : null}
                </ContentContainer>
              </div>

              <div className={'policy-content-box map-icon'} style={{ marginBottom: '-35px' }}>
                <img src={ this.setImage(ministry, gameState.gameStateSum[`${ministry}_value`], gameState.difficulty.toLowerCase()) } alt={__(ministry)}/>
                <img className={'plateau'} src={ this.setPlateau(ministry, gameState.gameStateSum[`${ministry}_value`], gameState.difficulty.toLowerCase()) } alt={'plateau'}/>
                <img className={'shadow'} src={Shadow} alt={'shadow'}/>
              </div>
            </div>

            <SectionHeading
              style={{ marginTop: '20px' }}
              className={"noMargin"}
              icon={Beleidskeuze}
              title={__n('sim_beleidskeuze', 0)}
              popupId={'dhgvtbeleidskeuzes'}/>
            <div className="policiesWrap">
            {policiesForMinisterie(policyChoice, ministry).map(
              (choice, key) => (
                <PolicyElement
                  key={ministry + choice.Nummer + key}
                  title={choice[`titel_beleidskeuze_${gameState.language}`]}
                  globas={parseInt(choice.kosten_globas[0], 10)}
                  collaborationGlobas={choice.kosten_globas.length > 1 ? parseInt(choice.kosten_globas[1], 10) : 0}
                  value={policyChoices[choice.omschrijving] || {}}
                  onChange={(v) => {
                    if(v.selected === false) {
                      delete policyChoices[choice.omschrijving];
                      dispatch(updateMyState({
                        policyChoices: policyChoices,
                      }))
                    } else {
                      const newPolicyChoices = { ...policyChoices, [choice.omschrijving]:{...v, ministry, nummer: choice.Nummer} };
                      const numChoices = getSelectedPolicyChoicesCount(newPolicyChoices);
                      if (numChoices > 10) {
                        this.setState({ allChoicesMadePopup: true });
                        return;
                      }
                      if (v.option && globas - v.globas < 0) {
                        return;
                      }
                      this.maxVal = undefined;
                      dispatch(updateMyState({
                        policyChoices: newPolicyChoices,
                      }))
                    }
                  }}
                >
                  {choice[`tekst_beleidskeuze_${gameState.language}`]}
                </PolicyElement>
              )
            )}
          </div>
            { this.state.allChoicesMadePopup ? (
              <PopUp interactive closePopUpCross closePopUpClick={() => { this.setState({ allChoicesMadePopup: false }); }}>
                {__('sim_maximum_beleidskeuzes_bereikt')}
              </PopUp>
            ) : null }
          </div>
        </Scrollbar>
        <NextStep/>
      </div>
    );
  }
}

export default connect(({user, gameState, feedback, gameStateInput, policyChoice, project}) => ({user, policyChoice, gameState, feedback, project, loaded: gameStateInput.loaded, myState: gameStateInput.myState, gameStateInput}))(MinistryBudget);



// WEBPACK FOOTER //
// ./src/components/desktop/MinistryBudget.js